import { Address } from '../../../forms/form-wrapper.types';
import { CollectionName } from '../../constants';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const migrateAddressFields = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...data };

  const createAddressFromFields = ({
    country,
    zipCode,
    district,
    province,
    city,
    street,
    buildingNumber,
    apartment,
  }: Record<string, unknown>): Address | undefined => {
    if (
      !country &&
      !zipCode &&
      !district &&
      !province &&
      !city &&
      !street &&
      !buildingNumber &&
      !apartment
    ) {
      return undefined;
    }

    return {
      country,
      zipCode,
      district: district || province,
      city,
      street,
      buildingNumber,
      apartment,
    } as Address;
  };

  if ('address' in newData && typeof newData.address === 'string' && newData.address) {
    delete newData.address;
  }

  if (
    'zipCode' in newData ||
    'district' in newData ||
    'province' in newData ||
    'city' in newData ||
    'street' in newData ||
    'buildingNumber' in newData ||
    'apartment' in newData
  ) {
    const addressObj = createAddressFromFields(newData);

    if (addressObj) {
      newData.address = addressObj;
    }

    delete newData.zipCode;
    delete newData.district;
    delete newData.province;
    delete newData.city;
    delete newData.street;
    delete newData.buildingNumber;
    delete newData.apartment;
  }

  if ('zip' in newData) {
    if (newData.address && typeof newData.address === 'object') {
      (newData.address as Address).zipCode = newData.zip as string;
    }
    delete newData.zip;
  }

  if ('apartmentNumber' in newData) {
    if (newData.address && typeof newData.address === 'object') {
      (newData.address as Address).apartment = newData.apartmentNumber as string;
    }
    delete newData.apartmentNumber;
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.ASSETS, migrateItemFunction: migrateAddressFields },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration17: MigrationType = {
  migrate,
  version: 18,
};
